import { render, staticRenderFns } from "./clickAudio.vue?vue&type=template&id=755d88a4&"
import script from "./clickAudio.vue?vue&type=script&lang=js&"
export * from "./clickAudio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports